import styled, { keyframes } from "styled-components";
import { paletas } from "../../../styles/theme";

interface ProgressoProps {
  valor: number;
}

export const Wrapper = styled.header`
  max-height: 50px;
  overflow: hidden;
  width: 100%;
  transition: all 0.25s;

  #devcoin,
  #pdl {
    font-size: 12px;
    font-weight: 500;
    font-family: "Bebas Neue", cursive;
    font-family: "Open Sans", sans-serif;
    font-family: "Poppins", sans-serif;
  }

  .no-mobile {
    @media (max-width: 400px) {
      display: none;
    }
  }

  .avatar {
    position: relative;
    height: 40px;
    width: 40px;
    background: rgba(255, 255, 255, 0.1);
    border: none;
    border-radius: 50%;
    padding: 2px;
    margin-right: 10px;

    img {
      width: 100%;
      max-width: 38px;
      border-radius: 50%;
      object-fit: cover;
      overflow: hidden;
    }
  }

  .conteudo-usuario {
    .box {
      margin-bottom: 5px;

      p {
        color: ${paletas.White};
      }

      span {
        margin: 0px 5px 0px;
        color: ${paletas.White};
      }

      .secundario {
        width: 100%;
        font-size: 14px;

        .devcoin {
          &:hover {
            transition: all 0.25s;
            transform: rotate(90deg) scale(1.3);
            filter: brightness(1.2);
          }
        }
      }
    }
  }
`;

export const Icone = styled.div`
  position: relative;
  display: inline;
`;

export const Progress = styled.div<ProgressoProps>`
  width: 100%;
  height: 10px;
  border-radius: 0.25rem;
  background-color: rgba(225, 225, 225, 0.1);
  position: relative;

  &:before {
    position: absolute;
    content: "";
    width: ${(props) => props.valor}%;
    max-width: calc(100% - 10px);
    height: 4px;
    border-radius: 0.25rem;
    background: -moz-linear-gradient(
      45deg,
      ${paletas.RedTheme} 0%,
      ${paletas.Gold} 100%
    );
    background: -webkit-linear-gradient(
      45deg,
      ${paletas.RedTheme} 0%,
      ${paletas.Gold} 100%
    );
    background: -o-linear-gradient(
      45deg,
      ${paletas.RedTheme} 0%,
      ${paletas.Gold} 100%
    );
    background: -ms-linear-gradient(
      45deg,
      ${paletas.RedTheme} 0%,
      ${paletas.Gold} 100%
    );
    background: linear-gradient(
      45deg,
      ${paletas.RedTheme} 0%,
      ${paletas.Gold} 100%
    );
    transition: all 0.25s;
    margin: 3px 5px 3px;
  }
`;

const animaLevelUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0%);
  }
`;

export const Mensagem = styled.div`
  position: absolute;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 3;
  transition: all 0.25s;
  backdrop-filter: blur(10px);

  &.mostrar {
    div {
      width: 100%;
      max-width: 300px;
      height: 50vh;
      margin: 25vh auto;
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
      flex-direction: column;
      padding: 20px;
      border-radius: 0.25rem;
      background-color: rgba(0, 0, 0, 0.5);
      box-shadow: 0px 0px 80px rgba(255, 255, 255, 0.3);

      transition: all 0.25s;

      animation: 0.25s ${animaLevelUp} ease-in-out;

      -webkit-transform-style: preserve-3d;
      -moz-transform-style: preserve-3d;
      -ms-transform-style: preserve-3d;
      transform-style: flat;

      &:hover {
        svg,
        span {
          transition: all 0.25s;
          transform: scale(1.1);
        }
        button {
          transform: scale(0.9);
        }
      }
    }

    span {
      position: absolute;
      font-size: 24px;
      font-weight: bold;
      margin-top: -80px;
      color: ${paletas.Grafite75};
    }

    h2,
    h3,
    p,
    button {
      margin: 10px 0;
    }

    h2,
    p {
      color: ${paletas.White};
    }

    button {
      font-size: 18px;
      font-weight: bold;
      width: 100%;
      max-width: 100px;
      padding: 10px;
      border: none;
      border-radius: 0.25rem;
      transition: all 0.25s;
      background-color: ${paletas.GreenMunsell};
      color: ${paletas.White};

      &:hover {
        color: ${paletas.Grafite25};
      }
    }
  }

  &.fechar {
    display: none;
  }
`;
